import React, { useState } from "react";
import { useWatch } from "react-hook-form";

import {
  AmountCard,
  FormRow,
  SelectSheet,
  SelectSheetOption,
} from "../../MobileForm";
import { Card, CardLabel, HelperText, RowsCard } from "../../MobileForm/styles";
import { FormInput, InputDate } from "../../Input";
import { localToday } from "../../../utils/dates";
import {
  ACCOUNT_RULES,
  ADD_CASHBACK_HELPER,
  AMOUNT_RULES,
  DATE_RULES,
  NOTE_RULES,
} from "./constants";
import { MobileAddCashbackFieldsProps } from "./types";

export const MobileAddCashbackFields: React.FC<
  MobileAddCashbackFieldsProps
> = ({ control, register, setValue, accountOptions, isSubmitting }) => {
  const [isAccountSheetOpen, setIsAccountSheetOpen] = useState(false);
  const account = useWatch({ control, name: "account" });
  register("account", ACCOUNT_RULES);

  const selectAccount = (option: SelectSheetOption) => {
    setValue("account", option, { shouldDirty: true, shouldValidate: true });
    setIsAccountSheetOpen(false);
  };

  return (
    <>
      <AmountCard
        id="mobile-add-cashback-amount"
        label="Amount *"
        control={control}
        rules={AMOUNT_RULES}
        tone="income"
        disabled={isSubmitting}
        required
      >
        <HelperText>{ADD_CASHBACK_HELPER}</HelperText>
      </AmountCard>

      <Card>
        <CardLabel htmlFor="mobile-add-cashback-date">Date *</CardLabel>
        <InputDate
          id="mobile-add-cashback-date"
          name="transactionDate"
          control={control}
          rules={DATE_RULES}
          maxDate={localToday()}
          placeholder="YYYY/MM/DD"
          disabled={isSubmitting}
        />
      </Card>

      <RowsCard>
        <FormRow
          label="Account *"
          value={account?.label}
          placeholder="Select account"
          onClick={() => setIsAccountSheetOpen(true)}
        />
      </RowsCard>
      <SelectSheet
        isOpen={isAccountSheetOpen}
        title="Account"
        options={accountOptions}
        selectedValue={account?.value}
        onSelect={selectAccount}
        onClose={() => setIsAccountSheetOpen(false)}
      />

      <Card>
        <CardLabel htmlFor="mobile-add-cashback-note">Description</CardLabel>
        <FormInput
          id="mobile-add-cashback-note"
          name="note"
          control={control}
          rules={NOTE_RULES}
          handleClear={false}
          disabled={isSubmitting}
          placeholder="Optional description"
        />
      </Card>
    </>
  );
};
